import { ReactNode } from 'react';
import { Box, Paper } from '@mui/material';
import smoothScroll from '../../utils/smoothScroll';
import RouterLink from '../link/RouterLink';
import GaTracker from '../../utils/GaTracker/GaTracker';

type Props = {
  title: ReactNode;
  icon: ReactNode;
  link: string;
};

export default function LinkCard(props: Props): JSX.Element {
  const { icon, title, link } = props;

  const content = (
    <Paper
      sx={{
        cursor: 'pointer',
        py: { xs: '0.75rem', sm: '1rem' },
        px: { xs: '0.75rem', sm: '1.1rem' },
        height: '100%',
        width: '150px',
        minHeight: '120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        boxShadow: 2,
        '&:hover': {
          boxShadow: 5,
        },
      }}
    >
      <Box width="50px">{icon}</Box>
      <Box fontWeight="500" fontSize="0.85rem">
        {title}
      </Box>
    </Paper>
  );

  return link[0] === '#' ? (
    <Box
      component="a"
      onClick={() => {
        GaTracker.trackEvent({
          category: 'Link',
          action: `click-scroll-to-${link.replace('#', '').replaceAll('/', '-').toLowerCase()}`,
          label: 'LinkCard',
        });
        smoothScroll(link);
      }}
    >
      {content}
    </Box>
  ) : (
    <RouterLink to={props.link || ''} style={{ textDecoration: 'none' }}>
      {content}
    </RouterLink>
  );
}
